import {gql} from "@apollo/client";
import {SELECT_OPTION_FIELDS } from "graphql/types/SelectOptionType";

export const LIST_WAREHOUSES_UNDER_HUB_OPTIONS = gql`
    query WarehousesUnderHubQuery($hubSortingCode: String!) {
        allOptions: getWarehousesUnderHubOptions(hubSortingCode: $hubSortingCode) {
            ...SelectOptionFields
        }
    }
    ${SELECT_OPTION_FIELDS}
`;
